/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';

import Utr from '../../text/Utr';
import PlayerLookupInput from './PlayerSelect/PlayerLookupInput';
import { arraysAreSame } from '../../../utils/comparator';
import { newGuid, getPlayerName } from '../../../utils';
import BackgroundImage from '../../BackgroundImage';

import styles from './playerSelect.scss';

const _ = { find };

class DoublesPlayerSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            team: null,
            position1: null,
            position2: null,
        };

        this.updatePlayers = this.updatePlayers.bind(this);
        this.playerSelect = this.playerSelect.bind(this);
        this.teamExists = this.teamExists.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.updatePlayers();
    }

    // UNSAFE_componentWillReceiveProps() {
    //     this.updatePlayers();
    // }

    updatePlayers() {
        const { match, position, playersDict, teamsDict } = this.props;
        let team; let player1; let
            player2;

        if (match[position] && match[position].id && match[position].type && match[position].type.value === 'team' && Object.keys(teamsDict).length > 0) {
            team = teamsDict[match[position].id];
            if (team) {
                player1 = playersDict[team.players[0]];
                player2 = playersDict[team.players[1]];
                this.setState({
                    team,
                    position1: player1,
                    position2: player2,
                });
            }
        }
    }

    teamExists(playersArr) {
        const { teams } = this.props;
        return _.find(teams, (team) => {
            return arraysAreSame(playersArr, team.players);
        });
    }

    playerSelect(pos, player) {
        console.log('playerSelect', pos, player);
        const { position, onSelect } = this.props;
        let stateToUpdate = { [pos]: player };

        // in case of clear a player in doubles game as per FLX-304
        if (Object.keys(player).length === 0) {
            stateToUpdate = {
                position1: null,
                position2: null,
            };
        }
        this.setState({
            ...stateToUpdate,
        }, () => {
            const { position1, position2 } = this.state;
            if (position1 && position2) {
                const existingTeam = this.teamExists([position1.id, position2.id]);
                if (existingTeam) {
                    // select existing team
                    onSelect(position, {
                        id: existingTeam.id,
                        type: 'team',
                        players: [position1.id, position2.id],
                    });
                } else {
                    // create new team
                    onSelect(position, {
                        id: newGuid(),
                        type: 'team',
                        players: [position1.id, position2.id],
                    });
                }
            } else if (!position1 && !position2) {
                onSelect(position, {
                    type: 'team',
                    players: null,
                });
            }
        });
    }

    render() {
        const {
            drawFormatType,
            match,
            playerOptions,
            playersDict,
            teamsDict,
            utrType,
            allowPlayerChange,
            showBye,
            position,
            onSelect,
            teams,
            clubProfileImages,
            teamName,
            showTeamName,
            sportTypeId,
            'data-testid': dataTestId,
        } = this.props;
        const { team, position1, position2 } = this.state;

        function utrById(playerId) {
            const player = playersDict[playerId];
            return <Utr player={player} pbrClass={styles.pbr} force={{ ratingType: drawFormatType.value, utrType, showDecimals: true }} sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.utr-${playerId}`} />;
        }

        const showPlayerName = (playerObj) => {
            return playerObj && playerObj.displayName;
        };
        // console.log('DoublesPlayerSelect', match)

        const name1 = showPlayerName(position1) ? <span className="selected-name">{position1.displayName}<small> {utrById(position1.id)}</small></span> : 'Select a player';
        const name2 = showPlayerName(position2) ? <span className="selected-name">{position2.displayName}<small> {utrById(position2.id)}</small></span> : 'Select a player';
        const name1mobile = position1 ? <span className="selected-name">{getPlayerName(position1.firstName, position1.lastName, true)}<small> {utrById(position1.id)}</small></span> : 'Select a player';
        const name2mobile = position2 ? <span className="selected-name">{getPlayerName(position2.firstName, position2.lastName, true)}<small> {utrById(position2.id)}</small></span> : 'Select a player';

        let selectClass1;
        let selectClass2;
        if (!position1) {
            selectClass1 = 'empty';
        }
        if (!position2) {
            selectClass2 = 'empty';
        }

        return (
            <React.Fragment>
                <div className="player-input">
                    {!!clubProfileImages && (
                        <BackgroundImage
                            baseUrl={'/v1/club/'}
                            defaultImage={'/img/utr-ball--teal.svg'}
                            images={clubProfileImages}
                            imageType={'profile'}
                            parentStylesClass={'team-logo'}
                        />
                    )}
                    <PlayerLookupInput
                        {...this.props}
                        playerOptions={position2 ? playerOptions.filter(p => p.id !== position2.id) : playerOptions}
                        name={name1mobile}
                        utrById={utrById}
                        onSelect={this.playerSelect}
                        position={'position1'}
                        teamName={teamName}
                        showTeamName={showTeamName}
                        selectClass={selectClass1}
                        isMobile={true}
                        parentClass={`d-block d-md-none player-lookup-mobile`}
                        data-testid={dataTestId && `${dataTestId}.player1.mobile`}
                    />
                    <PlayerLookupInput
                        {...this.props}
                        playerOptions={position2 ? playerOptions.filter(p => p.id !== position2.id) : playerOptions}
                        name={name1}
                        utrById={utrById}
                        onSelect={this.playerSelect}
                        position={'position1'}
                        teamName={teamName}
                        showTeamName={showTeamName}
                        selectClass={selectClass1}
                        parentClass={`d-none d-md-block`}
                        data-testid={dataTestId && `${dataTestId}.player1.desktop`}
                    />
                </div>
                <div className="player-input">
                    {!!clubProfileImages && (
                        <BackgroundImage
                            baseUrl={'/v1/club/'}
                            defaultImage={'/img/utr-ball--teal.svg'}
                            images={clubProfileImages}
                            imageType={'profile'}
                            parentStylesClass={'team-logo'}
                        />
                    )}
                    <PlayerLookupInput
                        {...this.props}
                        playerOptions={position1 ? playerOptions.filter(p => p.id !== position1.id) : playerOptions}
                        name={name2mobile}
                        utrById={utrById}
                        onSelect={this.playerSelect}
                        position={'position2'}
                        teamName={teamName}
                        showTeamName={showTeamName}
                        selectClass={selectClass2}
                        isMobile={true}
                        parentClass={`d-block d-md-none player-lookup-mobile`}
                        data-testid={dataTestId && `${dataTestId}.player2.mobile`}
                    />
                    <PlayerLookupInput
                        {...this.props}
                        playerOptions={position1 ? playerOptions.filter(p => p.id !== position1.id) : playerOptions}
                        name={name2}
                        utrById={utrById}
                        onSelect={this.playerSelect}
                        position={'position2'}
                        teamName={teamName}
                        showTeamName={showTeamName}
                        selectClass={selectClass2}
                        parentClass={`d-none d-md-block`}
                        data-testid={dataTestId && `${dataTestId}.player2.desktop`}
                    />
                </div>
            </React.Fragment>
        );
    }
}
DoublesPlayerSelect.propTypes = {
    'data-testid': PropTypes.string,
};

DoublesPlayerSelect.defaultProps = {
    'data-testid': null,
};

export default DoublesPlayerSelect;
